<template>
  <div class="flex items-start gap-6">
    <!-- Avatar Section -->
    <div class="shrink-0" v-if="settings.show_avatar !== false">
      <div class="w-24 h-24 rounded-full text-white font-semibold text-2xl flex items-center justify-center shadow-md"
        :style="{backgroundColor: current_user.color || '#3B82F6'}">
        {{ initial }}
      </div>
    </div>

    <!-- User Details -->
    <div class="grow">
      <dl class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        <div class="space-y-1">
          <dt class="text-sm font-medium text-gray-500">Full Name</dt>
          <dd class="text-sm text-gray-900">{{ current_user.first_name }} {{ current_user.last_name }}</dd>
        </div>

        <div class="space-y-1">
          <dt class="text-sm font-medium text-gray-500">Email</dt>
          <dd class="text-sm text-gray-900">{{ current_user.email }}</dd>
        </div>

        <div class="space-y-1" v-if="current_user.username">
          <dt class="text-sm font-medium text-gray-500">Username</dt>
          <dd class="text-sm text-gray-900">{{ current_user.username }}</dd>
        </div>

        <div class="space-y-1" v-if="current_user.last_login && settings.show_last_login !== false">
          <dt class="text-sm font-medium text-gray-500">Last Login</dt>
          <dd class="text-sm text-gray-900">{{ formatDate(current_user.last_login) }}</dd>
        </div>
      </dl>

      <!-- Access Roles if available -->
      <div class="mt-6 pt-6 border-t border-gray-100"
           v-if="settings.show_roles !== false && current_user.access_roles && current_user.access_roles.length">
        <div class="flex items-center gap-3">
          <span class="text-sm font-medium text-gray-500">Access Roles</span>
          <div class="flex flex-wrap gap-2">
            <span v-for="role in current_user.access_roles" :key="role"
              class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {{ toProperCase(role) }}
            </span>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="mt-6 pt-6 border-t border-gray-100">
        <div class="flex items-center gap-2">
          <router-link
            to="/account/password/change"
            class="btn-primary"
          >
            <font-awesome-icon :icon="['fas', 'key']" class="text-xs" />
            Change Password
          </router-link>
          <button
            class="btn-danger"
            @click="handleLogout"
          >
            <font-awesome-icon :icon="['fas', 'right-from-bracket']" class="text-xs" />
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { toProperCase } from '@/utils/common'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faKey, faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import router from '../../../router'

library.add(faKey, faRightFromBracket)

export default {
  name: 'UserInfoCard',
  components: {
    FontAwesomeIcon
  },
  props: {
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('auth', ['current_user']),

    initial() {
      if (this.current_user && this.current_user.first_name && this.current_user.last_name) {
        return this.current_user.first_name.charAt(0) + this.current_user.last_name.charAt(0)
      } else if (this.current_user && this.current_user.username) {
        return this.current_user.username.substring(0, 2).toUpperCase()
      } else {
        return 'U'
      }
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    toProperCase,

    async handleLogout() {
      await this.logout()
      await router.push({ name: 'Login' })
    },

    formatDate(dateString) {
      if (!dateString) return '—'
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
/* Component-specific styles */
</style>
